import { render, staticRenderFns } from "./OrderStatuses.vue?vue&type=template&id=1e1f01b0"
import script from "./OrderStatuses.vue?vue&type=script&lang=js"
export * from "./OrderStatuses.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports